import * as React from 'react'
import { ReactElement } from 'react'
import { useFormikContext } from 'formik'
import { DateTime } from 'luxon'
import LegacyLocalDatePicker from '../../../../components/LegacyLocalDatePicker'
import ReportForm from './ReportForm'
import { DocumentGenerationType } from '../../../../hooks/document/useDocumentGenerationHandler'

export type InvoiceReportDto = {
    from: string
}

function ReportBody(): ReactElement {
    const { values, setFieldValue } = useFormikContext<InvoiceReportDto>()
    return (
        <>
            <LegacyLocalDatePicker
                value={values.from}
                onSelectDate={date => setFieldValue('from', date)}
                datePickerProps={{
                    label: 'Datum vanaf',
                    maxDate: new Date(),
                }}
            />
        </>
    )
}

export default function InvoiceReportForm(): ReactElement {
    return (
        <ReportForm<InvoiceReportDto>
            title="Inboeken uitgaande facturen"
            generationType={DocumentGenerationType.CostCentre}
            initialValues={{
                from: DateTime.local().minus({ months: 12 }).startOf('month').toISODate(),
            }}
        >
            <ReportBody />
        </ReportForm>
    )
}
